<template>
  <div>
    <ux-form
    ref="formRefSign"
    :messages="{ required: field => {
          const temp = field.replace('：','')
          return `请输入${temp}的值`
        } }"
    layout="horizontal"
    >
      <ux-form-item :class="{'view-info': modal === 'view'}" label="需求报价：" :wrapper-col="wrapperCol" :label-col="labelCol">
        <ux-field-decorator name="quotePrice" :rules="[{regex:/^\d+(\.\d{0,2})?$/, message: '请输入最多两位小数的数字'}, { required:true, message: '需求报价是必须的'}]">
          <ux-input v-if="modal === 'add'" v-model="form.quotePrice" />
          <span v-else>{{ form.quotePrice }}</span>
        </ux-field-decorator>
      </ux-form-item>
      <ux-form-item :class="{'view-info': modal === 'view'}" label="方案描述：" :wrapper-col="wrapperCol" :label-col="labelCol">
        <ux-field-decorator name="description" :rules="[{required:true, message:'请输入方案描述'}, {max:500, message:'方案描述不能超过500个字符'}]">
          <ux-textarea v-if="modal === 'add'" v-model="form.description" />
          <span v-else>{{ form.description }}</span>
        </ux-field-decorator>
      </ux-form-item>
      <ux-form-item :class="{'view-info': modal === 'view'}" label="方案附件：" :wrapper-col="wrapperCol" :label-col="labelCol">
        <div v-if="modal === 'add'">
          <ux-field-decorator name="applyEnclosureUrl" rules="required">
              <ux-upload v-model="fileList"
                        :disabled="fileList.length > 0"
                        :custom-request="customRequest" 
                        :before-upload="beforeUpload"
                        accept=".zip,.rar,.7z"
                        @change="uploadChange"
              >                     
                <ux-button icon="upload">
                  点击上传
                </ux-button>
                <span style="margin-left:8px" @click.stop>上传文件数量限制1个，单个文件大小不超过10M，文件格式仅支持压缩包；</span>
              </ux-upload>
          </ux-field-decorator>
        </div>
        <div v-else>
          <a v-if="form.applyEnclosureUrl" @click="downloadZip(form.applyEnclosureUrl)">下载附件</a>
        </div>
      </ux-form-item>
      <ux-form-item :class="{'view-info': modal === 'view'}" :wrapper-col="{ offset: 4 }">
        <div v-if="modal === 'add'">
          <!-- <ux-checkbox v-model="agree">
            同意<span class="protcol">苏宁服务市场定制需求服务协议</span>
          </ux-checkbox> -->
        </div>
      </ux-form-item>
      <ux-form-item v-if="modal === 'add'" :class="{'view-info': modal === 'view'}" :wrapper-col="{ offset: 4 }">
        <ux-button type="primary" @click="submit">
          提交
        </ux-button>
      </ux-form-item>
    </ux-form>

    <ux-modal v-model="signVislable">
        <div slot="title">
          温馨提示
        </div>
        <div class="content">
          <span>
            <img src="../../assets/info.png" alt="">
          </span>
          <span>请确认报名信息已完善，否则将影响方案评分</span>
        </div>
        <div slot="footer">
          <ux-button type="success" @click="confirmSign">
            确定
          </ux-button>
          <ux-button @click="cancelC">
            取消
          </ux-button>
        </div>
      </ux-modal>
  </div>
</template>
<script>
import { UxForm } from '@cloud-sn/uxcool';
import UxMessage from '@cloud-sn/uxcool/es/message';
import axios from 'axios';

export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    modal: {
      type: String,
      default: 'add'
    },
  },
  data() {
    return {
      labelCol: { sm: 4 },
      wrapperCol: { sm: 11 },
      fileList: [],
      agree: false,
      signVislable: false,
    }
  },
  methods: {
    confirmSign() {
      this.$emit('signDataChange', this.form);
      this.signVislable = false;
    },
    cancelC() {
      this.signVislable = false
    },
    customRequest(options) {
      const formData = new FormData();
      formData.append("attachment", options.file);
      formData.append("fileName", options.file.name);
      console.log(formData);
      axios.post('/fuwu/ajax/customTask/uploadFile.action', formData).then((res) => {
        if(res.data.errCode === '0000' && res.data && res.data.data) {
          UxMessage.success('文件上传成功');
          this.form.applyEnclosureUrl = res.data.data;
          this.fileList = [];
          this.fileList.push(options.file);
        } else {
          const errMsg = res.data.errMsg || '文件上传失败'
          UxMessage.error(errMsg);
        }
      }, () => {
        UxMessage.error('文件上传失败');
      })
    },
    beforeUpload(file) {
      const { type, size } = file;
      const isLt10M = size / 1024 / 1024 <= 10;
      if(!isLt10M) {
        UxMessage.error('文件大小不能超过10M')
        return false;
      }
    },
    uploadChange({ file, fileList}) {
      this.fileList = [];
      if(file.status === 'success') {
        this.fileList = fileList;
        // const url = file.response.data || '';
        // this.form.applyEnclosureUrl = url;
      }
      if(file.status === 'removed') {
         this.fileList = [];
         this.form.applyEnclosureUrl = '';
      }
    },
    submit() {
      const {
        $refs: { formRefSign },
      } = this;
      if(formRefSign) {
        formRefSign.validate().then(({ valid, values }) => {
          if (!valid) {
            return;
          }
          this.signVislable = true;
        });
      }
      
    },
    downloadZip(url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style scoped>
.view-info {
  margin-bottom: 0px;
}
.view-info label {
  color: #666666;
}
</style>